<template>
    <v-container fluid grid-list-lg class="pa-3">
        <v-layout row wrap>
			<v-flex xs12 sm12 md4 lg3>
                <v-card>
                    <v-toolbar dense prominent>
                        <v-toolbar-title>Performance Records</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                        </v-toolbar-items>
                    </v-toolbar>

                    <v-card-text>
                        <v-container class="pa-0">


                            <v-layout row wrap>
                                <v-flex>
                                    <v-text-field readonly label="User Name" box hide-details v-model="selected.username"></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex>
                                    <v-text-field readonly label="Full Name" box hide-details v-model="selected.full_name"></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex>
                                    <fieldset class="pa-2">
                                        <legend class="px-1 caption">Company : Dept</legend>
                                        <ol v-html="computed_company_dept"></ol>
                                    </fieldset>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex>
                                    <fieldset class="pa-2">
                                        <legend class="px-1 caption">Appraisals Result</legend>

                                        <table width="100%" border="1" style="border-collapse: collapse;">
                                            <tr>
                                                <th>Superior</th>
                                                <th>Self</th>
                                                <th>Peer</th>
                                            </tr>

                                            <tr style="text-align: center;" v-html="computed_appraisals_result"></tr>
                                        </table>
										<div class="text-xs-right">
											<v-btn small flat color="primary"
												:disabled="disabled_acknowledgement_btn"
												:href="'/Appraisal-Acknowledgement-Page?uuid=d9c21ea8-7887-4035-8c67-5510e07c143d&fpes_report_entries_id=' + selected._id"
												class="mr-0 mb-0">
												Acknowledgement Page <v-icon right dark>task</v-icon>
											</v-btn>
										</div>

                                    </fieldset>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
								<v-flex xs4>
                                    <v-text-field readonly label="EUL (day)" box hide-details v-model="selected.eul"></v-text-field>
                                </v-flex>

                                <v-flex xs4>
                                    <v-text-field readonly label="Lateness (min)" box hide-details v-model="selected.lateness"></v-text-field>
                                </v-flex>

                                <v-flex xs4>
                                    <v-text-field readonly label="MC (day)" box hide-details v-model="selected.mc"></v-text-field>
                                </v-flex>
                            </v-layout>

                            <v-layout row wrap>
                                <v-flex>
                                    <v-textarea readonly label="Remark" box hide-details v-model="selected.remark"></v-textarea>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>

            <v-flex xs12 sm12 md8 lg9>
                <v-card>
                    <v-toolbar dense prominent>
                        <v-toolbar-title>Activity Listing</v-toolbar-title>
                        <v-spacer></v-spacer>

                        <v-toolbar-items>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn color="primary"
										small
										fab v-on="on"
										:href="'/Submit-Evidence-Step2-Crud?uuid=33297989-4029-4a57-9aba-65724eb4cee0&fpes_report_entries_id=' + selected._id">
                                        <v-icon>add_circle_outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Submit New Activity</span>
                            </v-tooltip>
                        </v-toolbar-items>
                    </v-toolbar>

                    <v-card-text>
                        <v-data-table
							:pagination.sync="table.pagination"
							:total-items="table.total_items"
							:rows-per-page-items="table.rows_per_page_items"
							:headers="table.headers.filter((r) => r.viewable == true)"
							:loading="table.loading"
							:items="table.items">

							<template v-slot:items="props">
								<td class="px-0">
									<v-menu bottom right>
										<template v-slot:activator="{ on }">
											<v-btn small icon v-on="on">
												<v-icon color="primary">more_vert</v-icon>
											</v-btn>
										</template>

										<v-list dense class="pa-0">
											<v-list-tile :href="'/Submit-Evidence-Step2-Crud/?uuid=33297989-4029-4a57-9aba-65724eb4cee0&_id=' + props.item._id">
												<v-list-tile-action>
													<v-icon>search</v-icon>
												</v-list-tile-action>
												<v-list-tile-title>View</v-list-tile-title>
											</v-list-tile>
										</v-list>
									</v-menu>
								</td>
								<td>{{ epoch2date(props.item.created) }}</td>
								<td>{{ props.item.created_by }}</td>
								<td>{{ epoch2date(props.item.modified) }}</td>
								<td>{{ props.item.modified_by }}</td>
								<td>{{ props.item.full_description }}</td>
								<td>{{ props.item.category }}</td>
								<td class="text-xs-center">
									<span v-html="populate_PFSS_cell(props.item.thumbs)"></span>
								</td>
								<td class="text-xs-center">{{ props.item.uploaded_evidence.length }}</td>
								<td class="text-xs-center">{{ props.item.status }}</td>
							</template>
						</v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>


        </v-layout>
    </v-container>
</template>

<script>
import general from "../../functions/general";
import query_builder from "../../functions/query.builder";

export default {
    name:"Submit-Evidence-Crud",
    data() {
        return {
            selected : {
                _id:null,
                username:"",
                full_name:"",
                company_dept:"",
                appraisals:[],
				eul:null,
                lateness:null,
                mc:null,
                remark:"",
            },
			table: {
				headers: [
					{
						text: "",
						value: "",
						align: "left",
						sortable: false,
						viewable: true,
						type: "Number",
						class: "px-0",
						width: "30px",
					},
					{
						text: "ID",
						value: "_id",
						align: "left",
						sortable: false,
						viewable: false,
						type: "Number",
						class: "",
						width: "",
					},
					{
						text: "Created by",
						value: "created_by",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Created",
						value: "created",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Modified by",
						value: "modified_by",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Modified",
						value: "modified",
						align: "left",
						sortable: true,
						viewable: true,
						type: "Number",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Full Description",
						value: "full_description",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Category",
						value: "category",
						align: "left",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "PFSS",
						value: "thumbs",
						align: "center",
						sortable: false,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "#Evidences",
						value: "uploaded_evidence",
						align: "center",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
					{
						text: "Status",
						value: "status",
						align: "center",
						sortable: true,
						viewable: true,
						type: "String",
						class: "font-weight-black",
						width: "",
					},
				],
				items: [],
				loading: false,
				total_items: 0,
				rows_per_page_items: [25, 50, 100, 200, 1000],
				pagination: {
					descending: false,
					page: 1,
					rowsPerPage: 25,
					sortBy: "_id",
					totalItems: 100,
				},
			},
        };
    },
	watch: {
		"table.pagination": {
			handler: function () {
				this.reload_fpes_report_entries_listing();
			},
			deep: true,
		},
	},
    computed: {
        computed_company_dept(){
            let ret = "";

            if(this.selected.company_dept.length > 0){
                let company_arr = this.selected.company_dept.split(",");

                ret = "<li>" + company_arr.join("</li><li>") + "</li>"
            }
            return ret;
        },
        computed_appraisals_result() {
            let superior = [], self = [], peer = [];

			for(var i = 0 , m = this.selected.appraisals.length; i < m ; i++){
				let el = this.selected.appraisals[i];

				if(el.type.includes("Superior")){
					superior.push(el.ave_score);
				} else if(el.type.includes("Self")){
					self.push(el.ave_score);
				} else if(el.type.includes("Peer")){
					peer.push(el.ave_score);
				}
			}

			let html_text = `
			<td>${this.average_score(superior)}</td>
			<td>${this.average_score(self)}</td>
			<td>${this.average_score(peer)}</td>
			`;

			return html_text;
        },
		disabled_acknowledgement_btn(){
			var result = true;

			for (let index = 0; index < this.selected.appraisals.length; index++) {
				const element = this.selected.appraisals[index];

				if(element.type.includes("Superior") || element.type.includes("Self")){
					result = false;
					break;
				}
			}

			return result;
		}
    },
    methods: {
		epoch2date: general.App.epoch2LocaleDatetime,
		populate_PFSS_cell(value){
			var html = [];

			var up_count = 0;
			var down_count = 0;
			var down_icon = '<i aria-hidden="true" class="v-icon material-icons theme--light red--text" style="font-size: 17px;">thumb_down_off_alt</i>';
			var up_icon = '<i aria-hidden="true" class="v-icon material-icons theme--light green--text" style="font-size: 17px;">thumb_up_off_alt</i>';
			for(var i = 0, m = value.length; i < m; i++){
				var el = value[i];
				if(el.value == 1){
					up_count++;
				}else {
					down_count++;
				}
			}
			html.push(down_icon);
			html.push(down_count);
			html.push("<span class='pl-2'></span>");
			html.push(up_icon);
			html.push(up_count);

			return html.join("");
		},
		async reload_fpes_report_entries_listing() {
			if (!this.selected._id) {
				return;
			}
			var qb = new query_builder.QueryBuilder();

			qb.Table = "evidence_submited_listing";

			var rule = new query_builder.Rule();
			rule
				.field("fpes_report_entries_id")
				.operator(query_builder.A_STR_OPERATOR.EQUAL)
				.value(this.selected._id);
			qb.Where.rules.push(rule);

			qb.Limit = this.table.pagination.rowsPerPage;
			qb.Offset = this.table.pagination.page;
			//qb.Select = this.table.headers.filter(el => (el.viewable==true && el.value!="") || el.value=="_id");

			// must check sortBy before push in order array
			if (this.table.pagination.sortBy) {
				qb.Order = [
					{
						name: this.table.pagination.sortBy,
						descending: this.table.pagination.descending,
					},
				];
			}

			var res = await general.wBackEndComm.PostData("process_arango_qb/", qb);
			res = res.data;
			if (res.Status == 1) {
				this.table.items = res.Body[0].records;
				this.table.total_items = res.Body[0].total_records;
			} else {
				general.wMsgBox.Error(res.Description);
			}
		},
        average_score(list){
			let ret = "-";
			let list_length = list.length;

			if (list_length > 0){
				let sum_value = 0
				for(let i = 0; i < list_length; i++){
					sum_value += list[i];
				}

				ret = (sum_value / list_length).toFixed(2);
			}
			return ret;
		},
        async reload_fpes_report_entries() {
            if (!this.selected._id) {
                return;
            }
            var qb = new query_builder.QueryBuilder();

            qb.Table = "fpes_report_entries_view";

            var rule = new query_builder.Rule();
            rule
                .field("_id")
                .operator(query_builder.A_STR_OPERATOR.EQUAL)
                .value(this.selected._id);
            qb.Where.rules.push(rule);

            //qb.Limit = this.table.pagination.rowsPerPage;
            qb.Offset = 1;
            //qb.Select = this.table.headers.filter(el => (el.viewable==true && el.value!="") || el.value=="_id");

            var res = await general.wBackEndComm.PostData("process_arango_qb/", qb);
            res = res.data;
            if (res.Status == 1) {
                if(res.Body[0].records.length > 0){
                    let record = res.Body[0].records[0];

                    this.selected.username = record.username;
                    this.selected.full_name = record.full_name;
                    this.selected.company_dept = record.company_dept;
                    this.selected.appraisals = record.appraisals;
					this.selected.eul = record.eul;
                    this.selected.lateness = record.lateness;
                    this.selected.mc = record.mc;
                    this.selected.remark = record.remark;
                }

                // this.table.total_items = res.Body[0].total_records;
            } else {
                general.wMsgBox.Error(res.Description);
            }
        },
    },
    async mounted() {
        general.App.loader.show(this);
        general.App.set_page_title("mySuite : Evidence Listing Page");

        this.selected._id = general.App.getQueryString("_id");
        if(this.selected._id){
            await this.reload_fpes_report_entries();
        }

        general.App.loader.hide(this);
    },
};
</script>

<style></style>
